import ReactDatePicker from "react-datepicker";

import i18n from "../../i18n";
import BottomModal from "./BottomModal";

const DatePicker = ({
  value,
  label = "",
  minDate = null,
  maxDate = null,
  maxYears = 100,
  onChange,
  onClickOutside
}) => {
  return <BottomModal className="datepicker" onClickOutside={onClickOutside}>
    {label && <h2 className="datepicker__title">{label}</h2>}
    <ReactDatePicker
      inline
      showMonthDropdown
      showYearDropdown
      locale={i18n.language || "en"}
      selected={value}
      minDate={minDate}
      maxDate={maxDate}
      yearDropdownItemNumber={maxYears}
      onSelect={(date) => onChange(date)}
    />
  </BottomModal>
};

export default DatePicker;